import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { featureFlagReducer } from '@surfline/web-common';
import status from './status';
import map from './map';
import spot from './spot';
import units from './units';
import animations from './animations';
import subregion from './subregion';
import worldTaxonomy from './worldTaxonomy';
import components from './components';
import sessions from './sessions';
import swellEvents from './swellEvents';
import promotions from './promotions';
import deviceData from './deviceData';

/**
 * @param {import('history').History} history
 * @param {{[key: string]: import('redux').Reducer}} asyncReducers
 */
const rootReducer = (history, asyncReducers) =>
  combineReducers({
    map,
    units,
    router: connectRouter(history),
    status,
    animations,
    spot,
    sessions,
    subregion,
    flags: featureFlagReducer,
    worldTaxonomy,
    components,
    swellEvents,
    promotions,
    deviceData,
    ...asyncReducers,
  });

export default rootReducer;
